<template>
  <div>
    <div class="bg-primary">
      <div v-if="!searchResult || searchResult?.length == 0">
        <p class="font-bold">Keine Artikel</p>
        Es befinden sich aktuell noch keine Artikel in Ihrer Zwischenablage.
      </div>

      <div v-else>


        <div class="flex gap-1 mb-2">
          <button data-ui="delete-all-clipboard-taps"
              class="hover:bg-trader-blue  hover:text-white bg-white   flex items-center justify-center w-full"
              @click="warnToDeleteAllClipboardTaps">
            <i class="fa-solid fa-trash-can p-2"></i>
            Alles aus der Zwischenablage löschen
          </button>

          <div class="flex">
            <div @click="prevPage"
                 class="bg-white px-2 py-1 hover:bg-active hover:text-white cursor-pointer" data-ui="button-prev-page">
              <i class="fa-solid fa-arrow-left"></i>
            </div>

            <div @click="nextPage"
                 class="bg-white px-2 py-1 hover:bg-active hover:text-white cursor-pointer" data-ui="button-next-page">
              <i class="fa-solid fa-arrow-right"></i>
            </div>
          </div>
        </div>


        <div v-if="searchResult?.length > 0 && pageCount > 0" class="flex mb-2">
          Seiten {{ pageStart + 1 }} von {{ pageCount }}
        </div>

        <div class="grid grid-cols-3 gap-1" data-ui="clipBoard-elements">
          <div v-for="clipboard in clipboards" :key="clipboard.clipboardId"
               class="w-[100px] h-[128px]  bg-white relative flex flex-col overflow-hidden">

            <!-- ShowPreview Container -->
            <div class="relative flex items-center justify-center overflow-hidden flex-grow">
              <ShowPreviewProduct class="w-full h-full" :page-id="clipboard.clipboardPageID"
                                  :product-id="clipboard.clipboardProduktId"/>
            </div>
            <!-- Icons Container -->
            <div class="bg-trader-dark-gray w-full flex items-center">
              <div @click="openPreview(clipboard.clipboardPageID,clipboard.clipboardProduktId)"
                   class="flex items-center justify-center hover:bg-trader-blue hover:text-white h-6 w-1/3 text-center">
                <i class="fa-solid fa-magnifying-glass-plus"></i>
              </div>
              <div :data-ui='"clipboard-" + clipboard.clipboardId'
                   @click="placeProductOnPageFromClipboard(clipboard.clipboardProduktId, clipboard.articleID ,clipboard.clipboardId, clipboard.articleNumber)"
                   class="flex items-center justify-center hover:bg-trader-blue hover:text-white h-6 w-1/3 text-center">
                <i class="fa-solid fa-link"></i>
              </div>
              <div @click="deleteClipboard(clipboard.clipboardId)"
                   class="flex items-center justify-center hover:bg-trader-blue hover:text-white h-6 w-1/3 text-center">
                <i class="fa-solid fa-circle-xmark"></i>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div v-if="searchResult?.length > 6" @click="toggleMore" data-ui="toggle-more-clipboard"
         class="mt-2 flex justify-center bg-trader-dark-gray py-2 hover:bg-trader-hover-background hover:text-white cursor-pointer ">
      <div v-if="tabItemCount == 6" class="cursor-pointer">Mehr anzeigen</div>
      <div v-else class="cursor-pointer">Weniger anzeigen</div>
    </div>

  </div>
</template>
<script>
import {gql} from "@apollo/client/core";
import {eventBus} from "@/application/EventBus";
import index, {mapActions, mapState} from "vuex";
import Modal from "@/components/Dialogs/Modal.vue";
import apolloClient from "@/apolloClient";
import ShowPreviewProduct from "@/components/Preview/showPreviewProduct.vue";
import SignalBus from "@/application/SignalBus";
import ArticleOnMAgazine from "@/components/Dialogs/ArticleOnMAgazine.vue";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";

export default {
  name: "ClipboardTap.vue",
  data() {
    return {
      selectedOption: "clipboard",
      searchResult: [],
      leaveTimeout: null,
      pageStart: 0,
    };
  },
  components: {
    Modal,
    ShowPreviewProduct,
  },
  props: {
    page: {
      type: Object,
      default: {},
    },
    product: {
      type: Object,
      default: {},
    },
    activeProductIndex: {
      type: Number,
      default: 0,
    },
    onCLickReloadPage: {
      type: Function,
      default: () => {
      }
    },
  },
  computed: {
    ...mapState('settings', ['tabItemCount']),
    clipboards: function () {


      let searchResults = [];
      let i = this.tabItemCount * this.pageStart;
      let counter = 0;

      while (i < this.searchResult.length && counter < this.tabItemCount) {
        searchResults.push(this.searchResult[i]);
        i++;
        counter++;
      }
      return searchResults
    },

    pageCount: function () {
      if (this.searchResult == null || this.searchResult.length == 0) {
        return 1;
      }
      return Math.ceil(this.searchResult.length / this.tabItemCount);
    },
  },
  methods: {
    ...mapActions('settings', ['setTabItemCount']),

    toggleMore() {
      if (this.tabItemCount == 6) {
        this.setTabItemCount(9);
      } else {
        this.setTabItemCount(6);
      }
    },
    warnToDeleteAllClipboardTaps() {
      eventBus.openConfirm({
        title: "Zwischenablage leeren",
        message: "Möchten Sie wirklich alle Artikel aus der Zwischenablage löschen?",
        onAccept: () => {
          this.deleteAllClipboardTaps()
        }
      });
    },

    async deleteAllClipboardTaps() {
      const mutation = gql`
        mutation deleteAllClipboardTaps {
          deleteAllClipboardTaps {
            success
          }
        }
      `;

      try {
        const {data} = await apolloClient.mutate({mutation});
        await this.getClipboard();
      } catch (error) {
        console.error(error);
      }

    },

    openPreview(pageId, productID) {
      /*
      eventBus.openModal(showPreviewProduct, {
        pageId: this.page.pageId,
        productId: this.product.productId,
        templateId: this.productData.productTemplate.id,
        templateName: this.productData.productTemplate.name,
        showOptions: true,
        center: true,
        quality: 3,
      }, {
        fullSize: true,
      });
      */
      eventBus.openModal(ShowPreviewProduct, {
        pageId: pageId,
        productId: productID,
        showOptions: true,
        center: true,
        quality: 3,
      }, {
        fullSize: true,
      });
    },
    async placeProduct(pageId, articleNumber) {
      let placeholderId = this.page.products[this.activeProductIndex].placeholderId;
      const query = gql`
        query PlaceProduct($pageId: Int!, $articleNumber: String!, $placeholderId: Int!) {
          placeProductOnPage(input: {pageId: $pageId, articleNumber: $articleNumber, placeholderId: $placeholderId}) {
            success
            }
        }
      `;

      const variables = {
        pageId: parseInt(this.page.pageId),
        articleNumber: articleNumber,
        placeholderId: placeholderId
      };
      try {
        const {data} = await apolloClient.query({query, variables});
        //this.reloadPage();
      } catch (error) {
        console.error("placeProduct Clipboard", error)
      }
    },
    async placeProductOnPageFromClipboard(productID, articleNumberId, clipboardId, articleNumber) {

      if (this?.page?.products?.[this.activeProductIndex]?.placeholderId == null) {
        eventBus.openModal(SuccessConfirmation);
        eventBus.setData({
          title: "Kein Artikel ausgewählt",
          message: "Sie müssen zuerst einen Artikel auswählen um ein Artikel aus der Zwischenablage zu plazieren.",
        });
        return;
      }
      let placeholderId = this.page.products[this.activeProductIndex].placeholderId;


      const clipboardData = {
        pageID: this.page.pageId,
        productID: productID,
        articleNumberId: articleNumberId,
        clipboardId: clipboardId,
        virtualId: placeholderId,
      }

      const mutation = gql`
    mutation placeProductOnPageFromClipboard($clipboard: ClipboardInput!) {
      placeProductOnPageFromClipboard(clipboard: $clipboard) {
            success
            code
            message
      }
    }
  `;
      try {
        const variables = {
          clipboard: clipboardData
        };
        const {data} = await apolloClient.mutate({mutation, variables});

        if (data.placeProductOnPageFromClipboard.code == "ARTICLE_IS_ON_MAGAZINE") {
          eventBus.openModal(ArticleOnMAgazine);
          eventBus.setData({
            articleNumber: articleNumber,
          });
        }

        SignalBus.emit("formular-reload-clipboard");
        this.onCLickReloadPage();
        await this.getClipboard();


      } catch (error) {
        console.error("Fehler beim Clipboard zuweisen", error);
      }
    },

    async deleteClipboard(clipboardId) {

      const mutation = gql`
        mutation deleteClipboard($clipboardID: Int!) {
          deleteClipboard(clipboardID: $clipboardID) {
            success
          }
        }
      `;

      try {
        const variables = {
          clipboardID: clipboardId  // Ändern Sie 'clipboardId' in 'clipboardID', um mit der Mutation übereinzustimmen
        };

        const {data} = await apolloClient.mutate({mutation, variables});

        await this.getClipboard();
      } catch (error) {
        console.error(error);
      }
    },

    showModal(clipboardPath) {
      //eventBus.openModal(clipboardView);
      eventBus.setData({
        clipboard: clipboardPath,
        clipboards: this.clipboards,
        selectedIndex: index,
      });
    },
    formatDate(timestamp) {
      let date = new Date(timestamp * 1000); // Konvertieren Sie den Unix-Zeitstempel in ein JavaScript Datum
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`; // Formatieren Sie das Datum als DD-MM-YYYY
    },
    nextPage() {
      if (this.pageStart < this.pageCount - 1) {
        this.pageStart += 1;
      }
    },
    prevPage() {
      if (this.pageStart > 0) {
        this.pageStart -= 1;
      }
    },
    async getClipboard() {
      const query = gql`
        query GetClipboard {
          searchClipboard {
            clipboardId
            clipboardProduktId
            clipboardPageID
            clipboardTime
            clipboardUserId
            clipboardVision
            articleID
            articleNumber
          }
        }
      `;

      try {
        const {data} = await apolloClient.query({query});

        if (data.searchClipboard == null) {
          this.searchResult = [];
          return;
        }
        this.searchResult = data.searchClipboard;


      } catch (error) {
        this.searchResult = [];
        console.error(error);
      }
    },
  },
  created() {
    this.getClipboard();


  },
  mounted() {

    SignalBus.connect(this, "reload-clipboard", this.getClipboard);
    SignalBus.connect(this, "formular-reload-sidebar", this.getClipboard);
  },
  beforeUnmount() {
    SignalBus.disconnectAllFromParent(this);
  },
};
</script>
